import { BlankAPISuccess } from "../generics";

export enum HeaderTokenEnum {
  NoToken = "NoToken",
  Bearer = "Bearer",
}

export enum AuthStorageKey {
  jwt = "jwt",
  jwt_refresh = "jwt_refresh",
  jwt_token_type = "jwt_token_type",
}

export enum TokenScopes {
  "resetPassword" = "resetPassword",
}

export interface IJWTPayload {
  accessToken: string;
  refreshToken: string;
  tokenType: "Bearer";
}

export interface IMFARequiredResponse {
  requiresMFA: boolean;
  tempToken?: string;
  message: string;
  sid?: string;
}

// Union type for login response - either full JWT or MFA required
export type ILoginResponse = IJWTPayload | IMFARequiredResponse;

export interface IJWTPayloadCode {
  status: boolean;
}

export interface IJWTPayloadDecoded {
  user: {
    id: string;
    email: string;
    MFARequired: boolean;
  };
  iat: number;
  exp: number;
}

export interface IAuthPayload {
  email: string;
  password: string;
}

export type IForgotPayload = {
  email: string;
};

export type IForgotResponse = BlankAPISuccess;

export type IResetPayload = {
  resetToken: string;
  password: string;
};

export type IResetResponse = BlankAPISuccess;

export type IValidateTokenPayload = {
  token: string;
  scope: string;
};

export type IValidateTokenResponse = BlankAPISuccess;

export type IVerifyMFATokenResponse = BlankAPISuccess;
export type ISendMFATokenResponse = BlankAPISuccess;
